import {
  Investment,
  InvestmentPerformance,
  RealizedGainByBooking,
} from "@bn/api/apiv1";

export type GainLossValues = ReturnType<typeof extractGainLossValues>;

// The app has no global currency switch, so every figure is shown in the
// investment's own currency — the non-AC fields.
export const extractGainLossValues = (
  investment: Investment,
  realizedGainByBooking: RealizedGainByBooking,
  investmentPerformance: InvestmentPerformance
) => {
  return {
    purchasePrice: investment.purchasePrice || 0,
    purchaseValue: investment.purchaseValue || 0,
    currentMarketValue: investment.currentMarketValue || 0,
    returnOnInvestment: investment.returnOnInvestment || 0,
    returnOnInvestmentInPercent: investment.returnOnInvestmentInPercent || 0,
    netTotalGain: realizedGainByBooking.accumulatedGain?.netGain || 0,
    grossTradingGain:
      realizedGainByBooking.accumulatedTradingGain?.grossGain || 0,
    grossDividendGain:
      realizedGainByBooking.accumulatedDividendGain?.grossGain || 0,
    commission: -1 * (realizedGainByBooking.accumulatedGain?.commission || 0),
    taxAmount: -1 * (realizedGainByBooking.accumulatedGain?.taxAmount || 0),
    performance: investmentPerformance.inInvestmentCurrency,
    showIrr:
      (investmentPerformance.holdingTimeInYears || 0) >= 1 &&
      investmentPerformance.inInvestmentCurrency?.irr != null,
  };
};
